import { useRoutes } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useReducer, useSelector } from "react-redux";

// routes
//import AdminRoutes from "./AdminRoutes";
//import WebsiteRoutes from "./WebsiteRoutes";
//import AuthRoutes from "./AuthRoutes";

import WebsiteLayout from "../layout/website-layout";
import AuthLayout from "../layout/auth-layout";

import LandingPage from "../pages/website/landing-page";
import Profile from "../pages/website/profile";
import About from "../pages/website/about-us/index.jsx";
import Contact from "../pages/website/contact/index.jsx";
import Jobposts from "../pages/website/jobpost-list/index.jsx";
import JobDetails from "../pages/website/job-details";
import Services from "../pages/website/services";

import Auth from "../pages/common/auth";

import Candidates from "../pages/admin/candidates";
import Employers from "../pages/admin/employers";
import EmployerDetails from "../pages/admin/employers/details";
import JobPosts from "../pages/admin/job-posts";
import Settings from "../pages/admin/settings";
import JobPostDetails from "../pages/admin/job-post-details";
import Interviews from "../pages/admin/interviews";

import SamplePage from "../pages/sample-page";
import ForgotPassword from "../pages/common/auth/ForgotPassword";
import EmployerForm from "../pages/admin/employers/EmployerForm.jsx";
import CandidateSpecialization from "../pages/admin/master/candidate-specialization/index.jsx";
import EmployerSpecialization from "../pages/admin/master/employer-specialization/index.jsx";
import GeneralInfoForm from "../pages/admin/candidates/candidate-form/GeneralInfoForm.jsx";
import Dashboard from "../pages/admin/dashboard/index.jsx";
import PlacementRecords from "../pages/admin/placement-records/index.jsx";

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const { userId, userName, role, displayRole } = useSelector(
    (state) => state.userReducer
  );

  const WebsiteRoutes = {
    path: "/",
    element: <WebsiteLayout />,
    children: [
      {
        path: "/",
        element:
          role === 1 ? <Navigate to="/admin/dashboard" /> : <LandingPage />,
      },
      { path: "/about", element: <About /> },
      { path: "/jobs", element: <Jobposts /> },
      { path: "/jobdetails", element: <JobDetails /> },
      { path: "/contact", element: <Contact /> },
      {
        path: "/profile",
        element: role > 0 ? <Profile /> : <Navigate to="/" />,
      },
      { path: "/services", element: <Services /> },
    ],
  };

  const AuthRoutes = {
    path: "/",
    element: <AuthLayout />,
    children: [
      { path: "/auth", element: <Auth /> },
      { path: "/forgot-password", element: <ForgotPassword /> },
    ],
  };

  const AdminRoutes = {
    path: "/admin",
    element: <WebsiteLayout />,
    children: [
      {
        path: "/admin/jobposts",
        element: role === 1 ? <JobPosts /> : <Navigate to="/" />,
      },
      {
        path: "/admin/jobpost",
        element: role === 1 ? <JobPostDetails /> : <Navigate to="/" />,
      },
      {
        path: "/admin/candidates",
        element: role === 1 ? <Candidates /> : <Navigate to="/" />,
      },
      {
        path: "/admin/candidates/form",
        element:
          role === 1 || role === 4 ? <GeneralInfoForm /> : <Navigate to="/" />,
      },
      {
        path: "/admin/employers",
        element: role === 1 ? <Employers /> : <Navigate to="/" />,
      },
      {
        path: "/admin/employers/form",
        element: role === 1 ? <EmployerForm /> : <Navigate to="/" />,
      },
      {
        path: "/admin/employer-details",
        element: role === 1 ? <EmployerDetails /> : <Navigate to="/" />,
      },
      {
        path: "/admin/settings",
        element: role === 1 ? <Settings /> : <Navigate to="/" />,
      },
      {
        path: "/admin/interviews",
        element: role === 1 ? <Interviews /> : <Navigate to="/" />,
      },
      {
        path: "/admin/master/candidate-specialization",
        element: role === 1 ? <CandidateSpecialization /> : <Navigate to="/" />,
      },
      {
        path: "/admin/master/employer-specialization",
        element: role === 1 ? <EmployerSpecialization /> : <Navigate to="/" />,
      },
      {
        path: "/admin/dashboard",
        element: role === 1 ? <Dashboard /> : <Navigate to="/" />,
      },
      {
        path: "/admin/placement-records",
        element: role === 1 ? <PlacementRecords /> : <Navigate to="/" />,
      },
    ],
  };

  return useRoutes([AdminRoutes, WebsiteRoutes, AuthRoutes]);
}
